// src/components/layout/TopBar.tsx

import { useAppDispatch, useAppSelector } from '../../store/store';
import { toggleSideMenu } from '../../store/slices/layoutSlice';
import WorkspaceSwitcher from './WorkspaceSwitcher';
import AppSelector from './AppSelector';
// The attendance clock is Central's, rendered by the Shared presentation
// package through this thin adapter. CRM used to own a second clock here
// (ClockWidget → timeTrackingApi → TimeEntry); that was a separate, writable
// attendance truth and has been retired.
import { AttendanceHeaderQuickAction } from '../attendance/AttendanceHeaderQuickAction';
import NotificationBell from '../notifications/NotificationBell';

interface TopBarProps {
  title?: string;
}

export default function TopBar({ title }: TopBarProps) {
  const dispatch = useAppDispatch();
  const isSideMenuOpen = useAppSelector((state) => state.layout.isSideMenuOpen);

  return (
    <header className="fixed top-0 left-0 right-0 h-14 bg-white border-b border-gray-200 z-40 flex items-center justify-between px-4">
      <div className="flex items-center gap-3">
        <button
          onClick={() => dispatch(toggleSideMenu())}
          className="p-2 hover:bg-gray-100 rounded-lg"
          aria-label={isSideMenuOpen ? 'Close menu' : 'Open menu'}
        >
          <svg
            className="w-6 h-6 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isSideMenuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
        {title && <h1 className="text-lg font-semibold text-gray-900">{title}</h1>}
      </div>

      <div className="flex items-center gap-3">
        <AttendanceHeaderQuickAction />
        <NotificationBell />
        <AppSelector />
        <WorkspaceSwitcher />
      </div>
    </header>
  );
}
